export default {"src":"/_next/static/media/location.9d38a5c6.svg","height":90,"width":64};